import { Boot } from "@wangeditor/editor";
import { IButtonMenu, IDomEditor, DomEditor } from '@wangeditor/core'
class ResizeImgMenu {
  constructor() {
    this.title = '设置宽高'
    this.tag = 'button'
  }

  getValue(editor) {
  }
  getSelectedNode(editor) {
    return DomEditor.getSelectedNodeByType(editor, 'image')
  }

  isActive(editor) {
    return false
  }
  isDisabled(editor) {
    if (editor.selection == null) return true
    const imageNode = this.getSelectedNode(editor)
    if (imageNode == null) {
      return true
    }
    return false
  }
  exec(editor) {
    if (this.isDisabled(editor)) return;
    const imageNode = this.getSelectedNode(editor)
    editor.emit('execImgFn',imageNode)
  }
}

const resizeImgMenuConf = {
  key: 'setSize',
  factory() {
    return new ResizeImgMenu()
  }
}

Boot.registerMenu(resizeImgMenuConf)